<template>
  <ul class="payment-methods__list">
    <li
      v-for="method in paymentMethods"
      :key="method.value"
      class="payment-methods__list-item"
      @click="handlePaymentMethodSelect(method.value)"
    >
      <img :src="method.icon" :alt="method.name" />
      <p class="payment-methods__list-item-name">{{ method.name }}</p>
      <ChevronRightIcon />
    </li>
  </ul>
</template>

<script>
import CreditCardIcon from '@/assets/icons/payment/card.png'
import PaypalIcon from '@/assets/icons/payment/paypal.png'
import { ChevronRightIcon } from 'vue-feather-icons'

export default {
  name: 'PaymentMethodSelect',
  components: {
    ChevronRightIcon,
  },
  data() {
    return {
      paymentMethods: [
        {
          name: 'Credit or debit card',
          value: 'card',
          icon: CreditCardIcon,
        },
        {
          name: 'PayPal',
          value: 'paypal',
          icon: PaypalIcon,
        },
      ],
    }
  },
  methods: {
    handlePaymentMethodSelect(method) {
      this.$emit('change', method)
    },
  },
}
</script>

<style lang="scss" scoped>
.payment-methods {
  &__list {
    display: flex;
    flex-direction: column;
    gap: 10px;

    margin: 0;
    padding: 0;
    list-style-type: none;

    &-item {
      display: flex;
      gap: 15px;
      align-items: center;
      padding: 10px;
      border-radius: 10px;

      color: var(--white);
      cursor: pointer;

      &:hover {
        background: var(--glass-extra-light);
      }
      &:active {
        background: var(--glass-dark);
      }

      &-name {
        flex: 1;
        margin: 0;

        font-feature-settings: 'clig' off, 'liga' off;

        font-size: 0.875rem;
        font-style: normal;
        font-weight: 450;
        line-height: 1.25rem;
      }
    }
  }
}
</style>
